import { render, staticRenderFns } from "./AdminMenu.vue?vue&type=template&id=fad48c98&scoped=true&"
import script from "./AdminMenu.vue?vue&type=script&lang=ts&"
export * from "./AdminMenu.vue?vue&type=script&lang=ts&"
import style0 from "./AdminMenu.vue?vue&type=style&index=0&id=fad48c98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad48c98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('fad48c98', component.options)
    } else {
      api.reload('fad48c98', component.options)
    }
    module.hot.accept("./AdminMenu.vue?vue&type=template&id=fad48c98&scoped=true&", function () {
      api.rerender('fad48c98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/AdminMenu.vue"
export default component.exports